export default __webpack_public_path__ + "static/media/team-photo-1986.68c6c516.jpg";